import { getFormattedDate } from '../utils/utils';
import { getStatus, getOrderType } from './utils';

export class OrderListModel {
  constructor(data) {
    const {
      status,
      quoteStatus,
      productSelectionFM,
      productType,
      orderId,
      createdAt,
      updatedAt,
      orderCreatedBy,
      orderAssignedTo,
      channel,
      legalBusinessNameFM,
      completedAt
    } = data || {};
    this.status = getStatus(status, quoteStatus) || '-';
    this.createdBy = orderCreatedBy
      ? `${orderCreatedBy.firstName} ${orderCreatedBy.lastName}`
      : '';
    this.channel = channel ? channel.name : '-';
    this.typeOfInstallation = getOrderType(productSelectionFM, productType);
    this.orderId = orderId;
    this.updatedAt =
      (updatedAt && getFormattedDate(updatedAt, 'YYYY-MM-DD')) || '-';
    this.createdAt =
      (createdAt && getFormattedDate(createdAt, 'YYYY-MM-DD')) || '-';
    this.completedAt =
      (completedAt && getFormattedDate(completedAt, 'YYYY-MM-DD')) || '-';  
    this.assignee =
      orderAssignedTo && orderAssignedTo.length
        ? orderAssignedTo[0].label
        : '-';
    this.legalBusinessNameFM = legalBusinessNameFM ? legalBusinessNameFM : '-';
  }
}
